import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { RcsRoutes } from 'pages/settings/pages/rcs/route/type'
import { RcsPage } from 'pages/settings/pages/rcs/ui/RcsPage'
import { RcsCreate } from 'pages/settings/pages/rcs/ui/RcsCreate'
import { RcsWizardRouter } from 'pages/settings/pages/rcsV2/route/RcsWizardRouter'

export const RcsRouter = observer(() => {
  const { featureFlagsStore } = useEntitiesContext()

  return (
    <Routes>
      <Route index element={<RcsPage />} />
      <Route
        path={`${RcsRoutes.create}/*`}
        element={featureFlagsStore.rcs_compliance_v2 ? <RcsWizardRouter /> : <RcsCreate />}
      />
    </Routes>
  )
})
